import { render, staticRenderFns } from "./Promotion_edit_group.vue?vue&type=template&id=21a3a0bb&scoped=true&"
import script from "./Promotion_edit_group.vue?vue&type=script&lang=js&"
export * from "./Promotion_edit_group.vue?vue&type=script&lang=js&"
import style0 from "./Promotion_edit_group.vue?vue&type=style&index=0&id=21a3a0bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a3a0bb",
  null
  
)

export default component.exports